import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { buildMetadataSections } from '../../js/courseMetadata'

const loadCourseMetadata = (id) => ({
  type: 'LOAD_COURSE_METADATA',
  id,
  payload: {
    request: {
      url: `/v3/course/${id}/metadata`,
    },
  },
})

const renderRow = (row, index) => {
  switch (row.type) {
    case 'chips':
      return (
        <div className="course-metadata--row course-metadata--row-chips" key={index}>
          <span className="course-metadata--label">{row.label}</span>
          <div className="course-metadata--chips">
            {row.values.map((value, i) => (
              <span className="course-metadata--chip" key={i}>
                {value}
              </span>
            ))}
          </div>
        </div>
      )
    case 'bool':
      return (
        <div className="course-metadata--row" key={index}>
          <span className="course-metadata--label">{row.label}</span>
          <span
            className={`course-metadata--bool ${
              row.value ? 'is-yes' : 'is-no'
            }`}
          >
            <i className={`bi ${row.value ? 'bi-check-lg' : 'bi-x-lg'}`} />
          </span>
        </div>
      )
    case 'link':
      return (
        <div className="course-metadata--row" key={index}>
          <span className="course-metadata--label">{row.label}</span>
          <a
            className="course-metadata--value course-metadata--link"
            href={row.url}
            rel="noreferrer"
            target="_blank"
          >
            Open link <i className="bi bi-box-arrow-up-right" />
          </a>
        </div>
      )
    case 'block':
      return (
        <div className="course-metadata--row course-metadata--row-block" key={index}>
          <span className="course-metadata--label">{row.label}</span>
          <p className="course-metadata--block">{row.value}</p>
        </div>
      )
    case 'value':
    default:
      return (
        <div className="course-metadata--row" key={index}>
          <span className="course-metadata--label">{row.label}</span>
          <span className="course-metadata--value">{row.value}</span>
        </div>
      )
  }
}

// Community-editable "Course details" section, fetched on demand and keyed by course (group) id.
// Renders nothing until there's something to show (a missing metadata resource is a 404).
export default function CourseMetadata({ groupId }) {
  const dispatch = useDispatch()
  const entry = useSelector((state) => state.metadata[groupId])

  useEffect(() => {
    if (groupId == null) return
    if (!entry || (!entry.data && !entry.loading && !entry.notFound && !entry.error)) {
      dispatch(loadCourseMetadata(groupId))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupId])

  const sections = buildMetadataSections(entry && entry.data)

  if (entry && entry.loading && !entry.data) {
    return (
      <div className="course-metadata course-metadata--status">
        <span className="spinner-border spinner-border-sm" role="status" />
        <span>Loading course details…</span>
      </div>
    )
  }

  if (sections.length === 0) return null

  return (
    <section className="course-metadata">
      <h2>Course details</h2>
      {sections.map((section, index) => (
        <div className="course-metadata--group" key={index}>
          <h3 className="course-metadata--group-title">{section.title}</h3>
          <div className="course-metadata--rows">{section.rows.map(renderRow)}</div>
        </div>
      ))}
    </section>
  )
}
